import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import { editCheckListCategory, getAllCheckListCategories} from "../../../Services/CheckList/CheckListCategoryService";
import CompanyDocumentCategoryForm
    from "../../../Components/Forms/Pages/CompanyDocument/CompanyDocumentCategory/CompanyDocumentCategoryForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const EditCheckListCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);

    const form = useForm({
        defaultValues:
            {
                name: props.category?.name,
                parent: props.category?.parent,
            }
    });

    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(null);

    useEffect(() => {
        setDrawerTitle(strings.pages.companyDocument.companyDocumentCategory.editCompanyDocumentCategory.pageTitle);
    });

    useEffect(() => {
        fetch();
    },[])

    const fetch = () => {
        getAllCheckListCategories().then(response => {
            if (!response || !response.ok) {
                return;
            }
            setParents(response.data);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        data = {id: props.category.id, ...data}
        editCheckListCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onSubmit(response.data);
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <CompanyDocumentCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditCheckListCategory;
